import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FormInfoService } from '../services/dynamic-forms/form-info.service';
import { IDynamicFormGroupDefinition } from '../models/dynamic-form-group';

// Sets the FormGroupDefinition to be used within this form's scope
@Directive({
  selector: '[dynamicFormInfo]',
  providers: [FormInfoService],
})
export class DynamicFormLoadDirective {
  formInfo: IDynamicFormGroupDefinition;

  constructor(private viewContainer: ViewContainerRef, private templateRef: TemplateRef<any>) {}

  @Input() set dynamicFormInfo(formInfo: IDynamicFormGroupDefinition) {
    this.formInfo = formInfo;
    if (this.formInfo == null) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
